import { useMutation, useQueryClient } from '@tanstack/react-query'

import {
  createVndlyCandidate,
  type CreateVndlyCandidateParams,
} from 'api/admin/vndly/createVndlyCandidate'
import { vndlyKeys } from './keys'

export const useCreateVndlyCandidateMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (params: CreateVndlyCandidateParams) =>
      createVndlyCandidate(params),
    onSuccess: async () =>
      queryClient.invalidateQueries({ queryKey: vndlyKeys.candidateIssues() }),
  })
}
